// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__BVZQS","green":"Badge_green__s9VbV","gray":"Badge_gray__cdVuY","blue":"Badge_blue__eHkaB","red":"Badge_red__VFY-A","yellow":"Badge_yellow__9InDy"};